import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { event, pageview } from "./analytics";

// Hook to automatically track page views with user info
export const usePageTracking = (user) => {
  const location = useLocation();

  useEffect(() => {
    if (location.pathname) {
      const userInfo = user?.name ? { name: user.name } : null;
      pageview(location.pathname, userInfo);
    }
  }, [location.pathname, user?.name]);
};

export const useAnalytics = (user = null) => {
  const getUserSuffix = (data) => {
    console.log("user", user);
    const userName = user?.name || "Unknown User";
    return `${data} (${userName})`;
  };

  const trackLoadSearch = (searchParams) => {
    event({
      action: "load_search",
      origin: getUserSuffix(searchParams.origin),
      destination: getUserSuffix(searchParams.destination),
      truck_type: getUserSuffix(searchParams.truck_type),
      data_source: getUserSuffix(searchParams.data_source),
      is_backhaul: getUserSuffix(searchParams.is_backhaul),
    });
  };

  const trackLoadSave = (loadInfo) => {
    event({
      action: "load_save",
      entry_id: getUserSuffix(loadInfo.entry_id),
      rate: Number(loadInfo.rate),
      miles: Number(loadInfo.miles),
      revenue: Number(loadInfo.revenue),
      origin: getUserSuffix(loadInfo.origin),
      destination: getUserSuffix(loadInfo.destination),
    });
  };

  const trackPairLoadSave = (pairInfo) => {
    event({
      action: "pair_load_save",
      entry_id: getUserSuffix(pairInfo.entry_id),
      outbound_origin: getUserSuffix(pairInfo.outbound_origin),
      outbound_destination: getUserSuffix(pairInfo.outbound_destination),
      return_origin: getUserSuffix(pairInfo.return_origin),
      return_destination: getUserSuffix(pairInfo.return_destination),
      total_miles: Number(pairInfo.total_miles),
      deadhead_miles: Number(pairInfo.deadhead_miles),
      total_revenue: Number(pairInfo.total_revenue),
      total_rate: Number(pairInfo.total_rate),
    });
  };

  const trackLoadBook = (loadInfo) => {
    event({
      action: "load_book",
      entry_id: getUserSuffix(loadInfo.id),
      rate: Number(loadInfo.rate),
      miles: Number(loadInfo.miles),
      revenue: Number(loadInfo.revenue),
      origin: getUserSuffix(loadInfo.origin),
      destination: getUserSuffix(loadInfo.destination),
    });
  };

  const trackPairLoadBook = (pairInfo) => {
    event({
      action: "pair_load_book",
      entry_id: getUserSuffix(pairInfo.entry_id),
      outbound_origin: getUserSuffix(pairInfo.outbound_origin),
      outbound_destination: getUserSuffix(pairInfo.outbound_destination),
      return_origin: getUserSuffix(pairInfo.return_origin),
      return_destination: getUserSuffix(pairInfo.return_destination),
      total_miles: Number(pairInfo.total_miles),
      deadhead_miles: Number(pairInfo.deadhead_miles),
      total_revenue: Number(pairInfo.total_revenue),
      total_rate: Number(pairInfo.total_rate),
    });
  };

  const trackSubscriptionEvent = (planType) => {
    event({
      action: "subscription",
      plan_type: getUserSuffix(planType),
    });
  };

  const trackUserLogin = (method, email) => {
    event({
      action: "user_login",
      login_method: getUserSuffix(method),
      user_email: getUserSuffix(email),
    });
  };

  return {
    trackLoadSearch,
    trackLoadSave,
    trackPairLoadSave,
    trackLoadBook,
    trackPairLoadBook,
    trackSubscriptionEvent,
    trackUserLogin,
  };
};
